import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import middlewarePipeline from './middlewarePipeline'
import defaultRouters from './defaultRouters'
import adminRouters from './adminRouters'
import authRouters from './authRouters'

Vue.use(VueRouter)

const routes = [
  ...authRouters,
  ...defaultRouters,
  ...adminRouters,
  {
    path: '/404',
    component: () => import('@views/error/404'),
    name: 'error.404',
    meta: {
      title: 'Page not found!'
    }
  },
  {
    path: '/403',
    component: () => import('@views/error/403'),
    name: 'error.403',
    meta: {
      title: 'Limit permissions access!'
    }
  },
  {
    path: '/500',
    component: () => import('@views/error/500'),
    name: 'error.500',
    meta: {
      title: 'System error!'
    }
  },
  {
    path: '/error',
    component: () => import('@views/error/index'),
    name: 'error.index',
    meta: {
      title: 'Something went wrong!'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
    // scrollBehavior: () => ({ y: 0 })
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  // reset router
  router.matcher = newRouter.matcher
}

router.beforeEach(async (to, from, next) => {
  if (!to.meta || !to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = { to, from, next, store }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
